export default __webpack_public_path__ + "c81a713e92d52e435074a66f3ccb5453.png";